"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nomos = void 0;
const network_1 = require("../network");
const cosmos_1 = require("../utils/cosmos");
class Nomos {
    constructor() {
        this.init = (provider) => __awaiter(this, void 0, void 0, function* () {
            const chainId = (yield provider.getChainId());
            if (!network_1.SUPPORTED_CHAINS.includes(chainId))
                throw new Error('Chain not supported');
            const config = (0, network_1.getNetworkConfig)(chainId);
            this.provider = provider;
            this.config = config;
        });
        this.createMultisig = (args, options) => __awaiter(this, void 0, void 0, function* () {
            const { members, minApproval, from } = args;
            const factory = (options === null || options === void 0 ? void 0 : options.factory) ? options.factory : this.config.contracts.factory.address;
            const deployMsg = {
                create_multisig: {
                    members,
                    min_approval: minApproval,
                },
            };
            const { events, transactionHash } = yield this.provider.execute(from, factory, deployMsg, 'auto');
            const multisig = (0, cosmos_1.getEventAttribute)([...events], 'instantiate', '_contract_address');
            return {
                multisig,
                transactionHash,
                events,
            };
        });
    }
}
exports.Nomos = Nomos;
//# sourceMappingURL=nomos.js.map